import React, { useState, useEffect } from 'react';
import { Row, Col } from "antd"
import './ChatComponents.css';

const THINKING_WORDS = [
    "Thinking",
    "Analyzing",
    "Reasoning",
    "Discombobulating",
    "Processing",
    "Consulting the oracle",
    "Crunching data",
    "Synthesizing",
    "Contemplating",
    "Calibrating",
    "Connecting dots",
    "Parsing context",
    "Cross-referencing",
    "Evaluating",
    "Assembling response",
    "Mapping dependencies",
    "Running analysis",
    "Checking knowledge base",
    "Formulating",
    "Deliberating",
    "Computing",
    "Investigating",
    "Querying systems",
    "Fetching records",
    "Validating inputs",
    "Correlating data",
    "Building response",
    "Brainstorming",
    "Considering options",
    "Weighing tradeoffs",
    "Reviewing context",
    "Structuring thoughts",
    "Drafting response",
    "Refining answer",
    "Double-checking",
    "Almost there",
    "Wrapping up",
    "Polishing",
    "Finalizing",
    "One moment",
    "Hang tight",
    "Working on it",
    "Deep in thought",
    "Piecing it together",
    "Sifting through info",
    "Noodling on it",
    "Ruminating",
    "Percolating",
    "Churning away",
    "Untangling",
];

const CBBTutorLoading = () => {
    const [wordIndex, setWordIndex] = useState(() => Math.floor(Math.random() * THINKING_WORDS.length));
    const [fade, setFade] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(false);
            setTimeout(() => {
                setWordIndex(Math.floor(Math.random() * THINKING_WORDS.length));
                setFade(true);
            }, 200);
        }, 2500);
        return () => clearInterval(interval);
    }, []);

    return (
        <Row>
            <Col span={24}>
                <div style={{ display: 'flex', width: '100%', gap: '14px', alignItems: 'flex-start' }}>
                    <div className="message-avatar message-avatar-assistant" title="QuickLab" style={{ background: 'transparent' }}>
                        <img src="/cat.gif" alt="thinking" style={{ width: 32, height: 32, objectFit: 'contain' }} />
                    </div>
                    <div className="message-content" style={{ paddingTop: '4px' }}>
                        <div className="thinking-animation">
                            <span className={`thinking-word ${fade ? 'visible' : ''}`}>
                                {THINKING_WORDS[wordIndex]}...
                            </span>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    )
}

export default CBBTutorLoading;